import { connect } from 'react-redux'
import CasesList from './CasesList'
import { getCases } from 'features/Cases/Cases.actions'
import { reduxForm } from 'redux-form'
import { get } from 'lodash'
import showCasesViewModal from '../CasesViewModal'

const stateToProps = ({ form, cases }) => ({
  cases: cases.cases
    .map(item => cases.casesById[item])
    .filter(item => item.recordType !== 'Product Order'),
  getCasesLoading: cases.getCasesLoading,
  initialValues: {
    filter: '',
  },
  formData: get(form, 'casesListForm.values', {}),
})

const dispatchToProps = {
  getCases,
  showCasesViewModal,
}

const CasesListForm = reduxForm({
  form: 'casesListForm',
})(CasesList)

export default connect(stateToProps, dispatchToProps)(CasesListForm)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesList/CasesList.container.js